var React = require('react');

function PlaceholderAudioFile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M640 830H0V0h440l83.59 102.37L640 200Z","fill":"#f3f4f6","key":0}),React.createElement("path",{"d":"M640 200H440V0Z","fill":"#e5e7eb","key":1}),React.createElement("path",{"d":"M128.25 348.19v150.92h56.46L306.06 577V272.23l-121.35 76ZM442.94 424.11c0-50.58-41-91.74-91.29-91.74v46.87c24.49 0 44.42 20.12 44.42 44.87S376.14 469 351.65 469v46.87c50.33 0 91.29-41.16 91.29-91.76Z","fill":"#9ca3af","key":2}),React.createElement("path",{"d":"M352.61 264v46.87c61.91 0 112.28 50.8 112.28 113.24s-50.37 113.26-112.28 113.26v46.87c87.75 0 159.14-71.84 159.14-160.12S440.36 264 352.61 264Z","fill":"#9ca3af","key":3})]);
}

PlaceholderAudioFile.defaultProps = {"id":"a240a6ca-b3df-4aeb-8870-224d880e4c39","data-name":"Layer 1","viewBox":"0 0 640 830"};

module.exports = PlaceholderAudioFile;

PlaceholderAudioFile.default = PlaceholderAudioFile;
